import { Component, type ErrorInfo, type ReactNode } from "react";
import { registrarErro } from "../lib/erros";

/**
 * Tela que quebrou mostra um aviso com saída em vez de deixar o coletor em branco, e o erro
 * vai para o registro do admin. Trocar de tela limpa o erro (a Moldura usa a rota como chave).
 */
export class ErroTela extends Component<{ children: ReactNode }, { erro: Error | null }> {
  state = { erro: null as Error | null };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    registrarErro(erro, { origem: "tela", componentes: info.componentStack?.slice(0, 1500) });
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div role="alert" className="mx-auto mt-6 flex max-w-xl flex-col gap-4 rounded-lg border-4 border-erro bg-erro-claro p-6">
        <h1 className="font-sinal text-2xl font-bold text-erro">Esta tela deu erro</h1>
        <p>O erro foi registrado para o admin. Recarregue a tela; se acontecer de novo, avise a liderança.</p>
        <p className="font-mono text-sm text-aco-escuro">{this.state.erro.message}</p>
        <div className="flex flex-wrap gap-3">
          <button type="button" onClick={() => window.location.reload()}
            className="min-h-12 rounded-md bg-tinta px-5 font-semibold text-white">Recarregar</button>
          <button type="button" onClick={() => { window.location.href = "/"; }}
            className="min-h-12 rounded-md border-2 border-tinta px-5 font-semibold">Voltar ao início</button>
        </div>
      </div>
    );
  }
}
